import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { FileStyled } from "../style";
import api from "../../../services/axios";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      // margin: theme.spacing(1),
      width: "100%",
    },
  },
}));
export default function AlertDialog(props) {
  const { t } = useTranslation();
  const [message, setMessage] = React.useState("");
  const [file, setFile] = React.useState(null);
  const [url, setUrl] = React.useState(null);
  const classes = useStyles();
  const handleClose = () => {
    props.func(false);
  };
  const getFile = async (url) => {
    if (props.data.file) {
      console.log(props.data);
      fetch(`${process.env.REACT_APP_API_URL}${props.data.file}`).then(
        async (res) => {
          const blob = await res.blob();
          blob.name = props.data.originalname;
          const file = new File([blob], props.data.originalname);
          setFile(file);
        }
      );

      return;
    }
  };
  React.useEffect(() => {
    setMessage(props.data.content);
    getFile();
  }, [props.data]);

  const confirm = () => {
    if (!message.length) {
      return window.alert("Preencha todos os campos marcados com *");
    }
    const data = {
      content: message,
      userfile: file,
      iddefaultmessages: props.data.iddefaultmessages,
    };
    console.log(data);
    const dataform = new FormData();
    for (const key in data) {
      dataform.append(key, data[key]);
    }
    api
      .put("defaultmessages", dataform, {
        headers: {
          Authorization: `Bearer ${localStorage.token}`,
        },
      })
      .then((res) => {
        props.update();
        handleClose();
      })
      .catch((err) => window.alert(err.response.data.error));
  };
  const handleFile = (event) => {
    setFile(event.currentTarget.files[0]);
  };
  React.useEffect(() => {
    console.log(file);
    if (file) {
      setUrl(URL.createObjectURL(file));
    } else {
      setUrl(null);
    }
  }, [file]);
  return (
    <div>
      <Dialog
        open
        fullWidth
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {" "}
          {t("DMT.dialogs.edit.title")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <form className={classes.root} noValidate autoComplete="off">
              {file && (
                <FileStyled url={url}>
                  <div className="filedescription">
                    <div className="place"></div>
                    <p className="namefile">{file.name}</p>
                  </div>
                  <p
                    onClick={() => {
                      setFile(null);
                    }}
                    style={{ color: "#f50057", cursor: "pointer" }}
                  >
                    Remover
                  </p>
                </FileStyled>
              )}
              <TextField
                id="outlined-multiline-static"
                label={t("DMT.dialogs.edit.ph")}
                multiline
                variant="outlined"
                rows={4}
                value={message}
                onChange={(e) => {
                  setMessage(e.currentTarget.value);
                }}
                required
              />
              {!file && (
                <>
                  {" "}
                  <Button color="primary">
                    <label for="file-upload">Anexa Arquivo</label>
                  </Button>
                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: "none" }}
                    onChange={handleFile}
                  />
                </>
              )}
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            <Button variant="contained" color="secondary">
              {t("DMT.dialogs.edit.bt2")}
            </Button>
          </Button>
          <Button color="primary" onClick={confirm} autoFocus>
            <Button variant="contained" color="primary">
              {t("DMT.dialogs.edit.bt1")}
            </Button>
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
